import { useRef } from 'react';
import { BreadcrumbItem } from '@celebration/react/ClbBreadcrumb/ClbBreadcrumb.types';
import Subheader from '../../../common/components/subheader';
import WonOfferConstants from './constants';
import WonOfferList from './components/won-offer-list/won-offer-list';
import HomeConstants from '../../home/constants';
import i18n from '../../../lib/i18n';
import WonOfferFilters from './components/won-offer-filters/won-offer-filters';
import OffersWonContext from '../../../app/contexts/offers-won';
import IWonFiltersModel from '../../../common/interfaces/IFiltersModel';

function WonOffers() {
    const filters = useRef<IWonFiltersModel>({} as IWonFiltersModel);

    const breadcrumbList = [
        {
            label: i18n.t(HomeConstants.PAGE_TITLE),
            url: HomeConstants.PATH,
        },
        {
            label: i18n.t(WonOfferConstants.PAGE_TITLE),
            url: WonOfferConstants.PATH,
        },
    ] as BreadcrumbItem[];

    return (
        <OffersWonContext.OffersWonProvider>
            <Subheader
                title={i18n.t('SmartCargas.WonOffers.MainTitle')}
                breadcrumbList={breadcrumbList}
                dataTestid="won-offer-subheader"
            />

            <WonOfferFilters filters={filters} />

            <WonOfferList filters={filters} />
        </OffersWonContext.OffersWonProvider>
    );
}

export default WonOffers;
